<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>{{ title }}</h2>
    <button type="button" mat-dialog-close class="btn-close btn-close-white" aria-label="Close">{{ cancelButtonText || 'Cancel' }}</button>
</div>
<form (ngSubmit)="onConfirm()">
    <div mat-dialog-content class="example-container pt-4">
          <p [innerHTML]="message"></p>
    </div>
    <div mat-dialog-actions class="row">
        <div class="col-12">
            <!-- Show custom buttons if provided -->
            <div class="text-center pb-2 d-flex justify-content-center" *ngIf="customButtons.length > 0">
                <button
                    type="button"
                    *ngFor="let button of customButtons"
                    [class]="'btn ' + (button.class || 'btn-primary') + ' mx-2'"
                    (click)="onCustomButtonClick(button)">
                    {{ button.text }}
                </button>
            </div>
            <!-- Show default confirm/cancel buttons if no custom buttons -->
            <div class="text-center pb-2 d-flex justify-content-center" *ngIf="customButtons.length === 0">
                <button type="button" class="btn btn-secondary me-2" *ngIf="showCancelButton" (click)="onCancel()"> {{ cancelButtonText || 'Cancel' }} </button>
                <button type="submit" class="btn btn-primary ms-2">{{ confirmButtonText || 'Yes' }}</button>
            </div>
        </div>
    </div>
</form>
